module.exports = __webpack_public_path__ + "static/media/LOGO-ITEC.b6b8be75.png";